import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-typography-2',
  templateUrl: './2.component.html',
  styleUrls: ['./2.component.scss'],
})
export class VbTypography2Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
